import './App.css';
import skylerfigmaheadshot from '../src/assets/skyler-figma-headshot.png';
import bitlyportfolioshot from '../src/assets/bitly-portfolio-shot.png';
import unicornstackportfolioshot from '../src/assets/unicornstack-portfolio-shot.png';
import laurencircleheadshot from '../src/assets/lauren-circle-headshot.png';
import megancircleheadshot from '../src/assets/megan-circle-headshot.png';
import React from 'react';
import { SocialIcon } from 'react-social-icons';
import Navbar from './components/Navbar';
import { HashRouter, Route, Redirect } from 'react-router-dom';
import Home from './components/Home';
import About from './components/About';
import Videos from './components/Videos';
import Projects from './components/Projects';
import Resources from './components/Resources';


function App() {
  return (
    <HashRouter>
    <div className="App">
      <header className="App-header">
        {/* <img src={logo} className="App-logo" alt="logo" /> */}
       <Navbar />
       <Route path='/home' component={Home} />
       <Route path='/about' component={About} />
       <Route path='/videos' component={Videos} />
       <Route path='/projects' component={Projects} />
       <Route path='/resources' component={Resources} />
       <Route exact path="/">
       <Redirect to="/home" />
       </Route>
       

        {/* <nav class="navbar">
        <span class="navbar-toggle" id="js-navbar-toggle">
            <i class="fas fa-bars"></i>
        </span>
        <a href="#" class="logo"><b>Skyler Basco</b></a>
        <ul class="main-nav" id="js-menu">
            <li>
              <a href="#" class="nav-links">Home</a> */}
                {/* <a href="#" class="nav-links">Home</a> */}
                {/* <Link to='/about'>Go to Aboutpage</Link> */}
                {/* <Link to="/SkylerCo" class="learn-more-button-yellow" target="_blank"><p>Learn more!</p></Link> */}
                {/* <Link to="/About" class="" target="_blank"><p>About</p></Link> */}
            {/* </li>
            <li>
                <a href="#" class="nav-links">About</a>
            </li>
            <li>
                <a href="#" class="nav-links">Videos</a>
            </li>
            <li>
                <a href="#" class="nav-links">Projects</a>
            </li>
            <li>
                <a href="#" class="nav-links">Resources</a>
            </li>
        </ul>
    </nav> */}

        {/* <div>
          <p>
          <b>
          Skyler Basco
          &nbsp; 
          </b>
          Home
          About 
          Videos
          Projects
          </p>
        </div> */}
        {/* <br/>

        <div className="firstlandingsection">
          <div className="skylerintrocolumnleft">
            <img className = "skylerfigmaheadshot" src={skylerfigmaheadshot} />
          </div>

          <div className="skylerintrocolumnright">
            <br/>
            <h1>
            <b>
            Hey, Skyler here!
            </b>
            </h1>
            <p>
            <p className="filmingjourneyline"> Filming my journey through tech while coding & designing fun things</p>
            ↳ Content Creator @ <a target="_blank" href="https://www.youtube.com/c/SkylerBasco" className="revuelinks">YouTube</a>
            <br/>
            ↳ Former SWE Intern @ <a target="_blank" href="https://bit.ly" className="revuelinks">Bitly</a>
            <br/>
            </p>
          </div>
        </div> */}

        {/* <br/>
        <br/>
       
        <div className="newestvideoslanding">
          <h1><b>In a nutshell, I...</b></h1>
        </div>


        <br/>
        <br/>

        <div className="backgroundnewvideos">
        <div className="newestvideoslanding">
        <br/>
          <h1><b>...create fun videos,</b></h1>
          <br/>
          <iframe className="recent-video" width="448" height="252" src="https://www.youtube.com/embed/Vfck2ivMA5E" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          <br/>
          <p>
          <h4>
          <a
            className="general-button"
            href="https://www.youtube.com/c/SkylerBasco"
            target="_blank"
            rel="noopener noreferrer"
          >
            See more on my channel!
          </a>
          </h4>
          </p>
          <br/>
        </div>
        </div>

        <br/>
        <br/>

        <div className="projectslandingsection">
          <h1 className="recentprojectslandingtitles">
          <b>
          ...code and design products, 
          </b>
          </h1>
          <br/> */}

          {/* <div className="projectscolumns">
            <img className = "landingportfolioshot" src={bitlyportfolioshot} />
            <h2>
            <b>
            Bitly API Explorer
            </b>
            </h2>
            <p>
            Easier space for users to interact with HTTP Request Methods from Bitly's API 
            </p>
            <h5>
            <a
              className="App-link"
              href="https://github.com/bitly/sprinterns2022"
              target="_blank"
              rel="noopener noreferrer"
            >
            Learn more
            </a>
            </h5>
          </div> */}
          
          {/* <div className="projectscolumns">
            <img className = "landingportfolioshot" src={unicornstackportfolioshot} />
            <br/>
            <h2>
            <b>
            Unicorn Stack
            </b>
            </h2>
            <p>
            Gamified platform to strengthen financial habits through AR, 3D models, budgeting.     
            </p>
            <h5>
            <a
              className="App-link"
              href="https://devpost.com/software/unicorn-stack"
              target="_blank"
              rel="noopener noreferrer"
            >
            Learn more
            </a>
            </h5>
          </div>

        
        </div>

        <div>
          <h4 className="recentprojectslandingtitles">
          <a
            className="general-button"
            href="https://devpost.com/software/unicorn-stack"
            target="_blank"
            rel="noopener noreferrer"
          >
          Explore all of my projects
          
          </a>
          </h4>
          <br/>
        </div> */}

     

        {/* <br/>
        <div className="peoplelandingsection">
        <br/>
          <h1 className="recentprojectslandingtitles">
          <br/>
          <br/>
          <b>
           
          ...collaborate with cool people,
          <br/>
          </b>
          <br/>
          </h1>
          <br/>

          <div className="peoplecolumns">
          <img className = "landingheadshot" src={laurencircleheadshot} />   
           <br/>
            <p>
            “Skyler possesses all of the attributes needed to <u className="peoplelinks">carry the future of tech</u> – 
            <br/>
            <br/>
            a passion so contagious that it inspires everyone around her towards excellence, a drive to take initiative and push the bounds of what is expected, and a <u className="peoplelinks">creative mind centered around empathy</u>.”
            <br/>
            <br/>
            - <u className="peoplelinks">Lauren Avilla</u>, Former Software Engineering Intern at Bitly 
            </p>
            <br/>
          </div>
          
          
          <div className="peoplecolumns">
          <img className = "landingheadshot" src={megancircleheadshot} />
            <br/>
            <p>
            “...I consistently began to see her <u className="peoplelinks">tremendous character & teamwork skills</u> in action. Skyler is creative and hardworking. 
            <br/>
            <br/>
            It is evident that she is a remarkable talent and a <u className="peoplelinks">promising entrepreneur</u>, and will be successful with her future endeavors.”
            <br/>
            <br/>
            - <u className="peoplelinks">Megan Stratton</u>, Student at Lehigh University 
            </p>
            <br/>
          </div>  
          <br/>  
        </div> */}

        {/* <br/>
        <br/>

        <div className="newsletterlanding">
          <h1><b>...and build community!</b></h1>
          <br/>
          <p>
          Let's stay in touch! Sign up for "Skyler's Tech Squad," a free newsletter where I share tech resources, motivation, and personal updates. <br/> <br/> By subscribing, you agree with Revue’s <a target="_blank" href="https://www.getrevue.co/terms" className="revuelinks">Terms of Service</a> and <a target="_blank" href="https://www.getrevue.co/privacy" className="revuelinks">Privacy Policy</a>.
          </p>

          <div id="revue-embed">
            <form action="https://www.getrevue.co/profile/skylerbasco/add_subscriber" method="post" id="revue-form" name="revue-form"  target="_blank">
            <div class="revue-form-group">
              {/* <label for="member_email">Email address</label> */}
              {/* <input class="revue-form-field" placeholder="Your email address..." type="email" name="member[email]" id="member_email"></input>
            </div> */} 
            {/* <div class="revue-form-group">
              <label for="member_first_name">First name <span class="optional">(Optional)</span></label>
              <br/>
              <input class="revue-form-field" placeholder="First name... (Optional)" type="text" name="member[first_name]" id="member_first_name"></input>
            </div>
            <div class="revue-form-group">
              <label for="member_last_name">Last name <span class="optional">(Optional)</span></label>
              <br/>
              <input class="revue-form-field" placeholder="Last name... (Optional)" type="text" name="member[last_name]" id="member_last_name"></input>
            </div> */}
            {/* <div class="revue-form-actions">
              <input type="submit" value="Subscribe" name="member[subscribe]" id="member_submit" className="subscribe-button"></input>
            </div>
            <br/>
            {/* <div class="revue-form-footer">By subscribing, you agree with Revue’s <a target="_blank" href="https://www.getrevue.co/terms" className="revuelinks">Terms of Service</a> and <a target="_blank" href="https://www.getrevue.co/privacy" className="revuelinks">Privacy Policy</a>.</div> */}
            {/* </form>
          </div>
        </div> */} 

        <div className="newestvideoslanding">
        <p class="socialsfooter">
        Thanks for scrolling by. Let's connect! 💭
        </p>       
          <SocialIcon url="https://www.linkedin.com/in/skylerbasco/" className="socialmediaicon"/>
        &nbsp;
          <SocialIcon url="https://www.youtube.com/c/SkylerBasco" className="socialmediaicon"/>
        &nbsp;
          <SocialIcon url="https://www.instagram.com/theskylerbasco/" className="socialmediaicon"/>
        &nbsp;
          {/* <SocialIcon url="https://github.com/skylerbasco" className="socialmediaicon"/>
        &nbsp; */}
          <SocialIcon url="mailto:theskylerbasco@gmail.com?subject = Feedback&body = Message" className="socialmediaicon"/>
          <p class="socialsfooter">
          © 2022 <a href="https://www.youtube.com/c/SkylerBasco" className="peoplelinks">Skyler Basco</a>. All Rights Reserved.
        </p>  
        </div>
        
        
        
      </header>
    </div>
    </HashRouter>
  );
}

export default App;
